import { render, staticRenderFns } from "./contactConfirmThisIsMe.vue?vue&type=template&id=54f4665e&lang=en"
import script from "./contactConfirmThisIsMe.vue?vue&type=script&lang=js"
export * from "./contactConfirmThisIsMe.vue?vue&type=script&lang=js"
import style0 from "./contactConfirmThisIsMe.vue?vue&type=style&index=0&id=54f4665e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports